import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mixins from './mixins'
import axios from 'axios'
import select2 from 'vue3-select2-component'
import VueCookies from 'vue-cookies'
import { createI18n } from 'vue-i18n'
import i18nKo from './assets/i18n/ko.json'
import i18nEn from './assets/i18n/en.json'

const messages = {
  ko: i18nKo,
  en: i18nEn
}

const i18n = createI18n({
  locale: 'ko',
  messages
})

const app = createApp(App)

app.config.globalProperties.$cookies = VueCookies
app.config.globalProperties.$axios = axios
app.config.globalProperties.$router = router
app.config.globalProperties.$store = store

app.use(router).use(store).use(VueCookies).use(i18n).mixin(mixins).component('Select2', select2).mount('#app')
